<template lang="pug">
  section.pb-60
    header.mt-53.mb-90.md-mb-120
      h1.text-18.md-text-24.text-center.leading-none Locations
      .md-hidden.mt-36.text-15.text-center.px-15(v-html="r(doc.acf.intro)")
    section.mx-auto.md-px-20.lg-w-xl.md-pt-10
      .md-w-grid-20.md--ml-20.md-px-10.md-flex.justify-between
        //- Shoreditch
        //- (mobile header)
        h3.md-hidden.text-18.mt-90.mb-30.text-center Shoreditch
        //- LEFT COLUMN
        .md-w-3x4.md-px-10.flex.flex-col.justify-between
          div
            h3.hidden.md-block.text-17 Shoreditch
            section.mt-30.md-w-grid-20.md--ml-20.md-px-10.flex.flex-wrap.justify-between.px-15(v-if="doc")
              //- locations # 1-3
              .w-full.mb-30.md-w-1x3.md-px-10.md-mb-0(v-for="(loc, i) in doc.acf.locations", v-if="i < 3", :class="{'text-app-accent': active === 'shore'}")
                //- no / spaces
                .flex.text-18.md-text-24
                  .w-30.mr-2 {{i + 1}}
                  .flex-1.ml-2.md-min-h-6em.whitespace-no-wrap(v-html="r(loc.spaces)")
                //- address / hours
                .w-full.mt-20.md-mt-30.children-mt-1em-2.text-13(v-html="r(loc.details)")
          .md-w-grid-20.md--ml-20.md-px-20.order-first.md-order-none
            figure.mt-30.md-mt-60.border-t.border-b.md-border.relative.pb-60pct.md-pb-0.md-h-460.lg-h-540
              //- (mobile img)
              template(v-if="!winIs('md')")
                img.absolute.inset-0.w-full.h-full.object-contain.md-hidden(src="@/assets/imgs/location-shoreditch.svg")
              //- (interactive svg)
              template(v-else)
                .absolute.inset-0.flex.items-center.overflow-hidden.trans-quicker(:class="{'opacity-50': hover === 'white'}", @mouseenter="hover = 'shore'", @mouseleave="reset")
                  .w-full.locations__fig--shoreditch.bg-contain.bg-no-repeat
                    svg-shoreditch-bldgs.block.w-full(:active="active === 'shore'", @hover="show('shore')", @hoverEnd="active = null")
        //- Whitechapel (small col)
        //- (mobile header)
        h3.md-hidden.text-18.mt-120.mb-30.text-center Whitechapel
        //- RIGHT COLUMN
        .md-w-1x4.md-px-10.flex.flex-col.justify-between
          div
            h3.hidden.md-block.text-17 Whitechapel
            //- locations # 4
            section.mt-30.px-15.md-px-0(v-if="doc && doc.acf.locations[3]", @mouseleave="reset", :class="{'text-app-accent': active === 'white'}")
              //- no / spaces
              .flex.text-18.md-text-24
                .w-30.mr-2 4
                .flex-1.ml-2.md-min-h-6em(v-html="doc.acf.locations[3].spaces")
              //- address / hours
              .w-full.mt-20.md-mt-30.children-mt-1em-2.text-13(v-html="doc.acf.locations[3].details")
          figure.order-first.md-order-none.mt-30.md-mt-60.border-t.border-b.md-border.relative.pb-60pct.md-pb-0.md-h-460.lg-h-540
            //- (mobile img)
            template(v-if="!winIs('md')")
              img.absolute.inset-0.w-full.h-full.object-contain.md-hidden(src="@/assets/imgs/location-whitechapel.svg")
            //- (interactive svg)
            template(v-else)
              .hidden.md-block.absolute.inset-0.flex.items-center.overflow-hidden.trans-quicker(:class="{'opacity-50': hover === 'shore'}", @mouseenter="hover = 'white'", @mouseleave="reset")
                .w-full.locations__fig--whitechapel.bg-contain.bg-no-repeat
                  //- TODO - mobile map img...
                  svg-whitechapel-bldgs.block.w-full(:active="active === 'white'", @hover="show('white')", @hoverEnd="active = null")
</template>

<script>
import { mapGetters } from 'vuex'
import { resolveAllLinks } from '@/utils'
import svgShoreditchBldgs from './SVG-ShoreditchBldgs'
import svgWhitechapelBldgs from './SVG-WhitechapelBldgs'
export default {
  name: 'Locations',
  props: ['doc'],
  data () {
    return {
      active: null,
      hover: null,
      r: resolveAllLinks
    }
  },
  computed: {
    ...mapGetters(['winIs'])
  },
  methods: {
    show (str) {
      this.active = str
    },
    reset () {
      this.active = null
      this.hover = null
    }
  },
  components: { svgShoreditchBldgs, svgWhitechapelBldgs }
}
</script>

<style>
.locations__fig--shoreditch{
  background-image:url('./shoreditch-map__map--min.jpg');
}
.locations__fig--whitechapel{
  background-image:url('./whitechapel-map__map--min.jpg');
}
</style>
